import type { AgeBand, WebCategory, WebFilter } from './types'

export const WEB_CATEGORY_LABELS: Record<WebCategory, { label: string; emoji: string }> = {
  adult: { label: 'Contenido adulto', emoji: '🔞' },
  gambling: { label: 'Apuestas', emoji: '🎰' },
  drugs: { label: 'Drogas', emoji: '💊' },
  social: { label: 'Redes sociales', emoji: '💬' },
  violence: { label: 'Violencia', emoji: '⚔️' },
}

export const AGE_BAND_LABELS: Record<AgeBand, { label: string; desc: string }> = {
  under13: { label: 'Menos de 13 años', desc: 'Bloquea contenido adulto, apuestas, drogas, redes sociales y violencia' },
  teen: { label: '13 a 17 años', desc: 'Bloquea contenido adulto, apuestas y drogas' },
  adult: { label: '18 años o más', desc: 'Sin restricciones por defecto' },
}

export const AGE_BAND_PRESETS: Record<AgeBand, Record<WebCategory, boolean>> = {
  under13: { adult: true, gambling: true, drugs: true, social: true, violence: true },
  teen: { adult: true, gambling: true, drugs: true, social: false, violence: false },
  adult: { adult: false, gambling: false, drugs: false, social: false, violence: false },
}

export function defaultWebFilter(): WebFilter {
  return {
    enabled: true,
    ageBand: 'under13',
    categories: { ...AGE_BAND_PRESETS.under13 },
    customDomains: [],
  }
}

export function presetFor(band: AgeBand): Record<WebCategory, boolean> {
  return { ...AGE_BAND_PRESETS[band] }
}
